function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.873 7.395a.654.654 0 00-.646.647v5.288c0 1.097-.816 1.968-1.829 1.968h-10.8c-1.04 0-1.828-.871-1.828-1.968V8.014a.654.654 0 00-.647-.647.636.636 0 00-.646.647v5.288c0 1.771 1.378 3.234 3.093 3.234h10.828c1.716 0 3.094-1.434 3.094-3.234V8.014c.028-.337-.281-.619-.619-.619z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.547 11.586a.664.664 0 00.45.197c.169 0 .31-.056.45-.197l3.431-3.403a.628.628 0 000-.9.628.628 0 00-.9 0L9.644 9.589V2.108a.654.654 0 00-.647-.647.654.654 0 00-.647.647v7.537L6.016 7.311a.628.628 0 00-.9 0 .628.628 0 000 .9l3.43 3.375z"
}));